import * as React from "react";
import Button from "../components/button";
import classNames from "classnames";
export class RevoMenuItemButton extends React.PureComponent {
    render() {
        const { icon, onClick } = this.props;
        return (React.createElement("div", { className: classNames({
                revoMenuItem__button: true,
                impersonate: this.props.isImpersonating,
            }) },
            React.createElement(Button, { type: "primary", icon: icon !== null && icon !== void 0 ? icon : undefined, onClick: onClick })));
    }
}
//# sourceMappingURL=revo-menu-item-button.js.map